import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const sophos = defineConnector({
  identifier: "sophos",
  name: "Sophos",
  tagLine: "Endpoint and network security platform",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api[^/]*\\.sophos\\.com/.*",
  auth: (app) =>
    oauthAuth.withHeaders([
      { name: "X-Tenant-ID", value: app.config.tenantId },
    ]),
  steps: [
    {
      title: "Create API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In [Sophos Central](https://central.sophos.com/), go to **Global Settings → API Credentials Management** and create a new credential. Copy the client ID, client secret, and your tenant ID.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Tenant ID",
          required: true,
          target: { kind: "configuration", field: "tenantId" },
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: () => "https://id.sophos.com/api/v2/oauth2/token",
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.central.sophos.com/whoami/v1",
  },
});
